//
//
//
//
//
//
//
//
//
//
//

import AlgoliaEditorial from '@/scripts/libs/algolia/editorial'
import RbAlgoliaBaseEditorialProducts from '@/elements/editorial/algolia/rb-algolia-base-editorial-products.vue'
export default {
  name: 'rb-algolia-editorial-products',
  components: {
    RbAlgoliaBaseEditorialProducts,
  },
  props: {
    groupedRule: {
      type: String,
      default: '',
    },
    ungroupedRule: {
      type: String,
      default: '',
    },
    maxNumber: {
      type: Number,
      default: 10,
    },
    isCluster: {
      type: Boolean,
      default: true,
    },
    dataElementId: {
      type: String,
      default: '',
    },
    internalContent: {
      type: Boolean,
      default: false,
    },
    wishlistIconIsVisible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      initialized: false,
      products: [],
    }
  },
  methods: {
    async onViewportIntersection(e, isIntersecting) {
      if (!this.initialized && isIntersecting) {
        this.initialized = true
        this.products = await AlgoliaEditorial.getEditorialProducts({
          groupedRule: this.groupedRule,
          isCluster: this.isCluster,
          maxNumber: this.maxNumber,
          ungroupedRule: this.ungroupedRule,
        })
      }
    },
  },
}
